import React, { useState } from 'react';
import loginService from '../controller/controller.login';
import NavBar from './commonHooks/commonHooks.navBar'; 
import DiscSignIn from './commonHooks/commonHooks.discSignIn';
import './css/sign.css'

const SignIn = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSignIn = async (event) => {
    event.preventDefault();
    try {
      const response = await loginService.signin(username, password);
      if (response) {
        setMessage('Sign-in successful!');
        window.location.href = '/'
      } else {
        setMessage('Sign-in failed. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="app-container">
      <NavBar /> {/* Render NavBar */}
      <div className="signin-container">
        <form onSubmit={handleSignIn}>
          <div className="form-group">
            <label htmlFor="username" className="label">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password" className="label">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              required
            />
          </div>
          <a href="/forgotpassword" className="forgot-password">Forgot password?</a>
          <button type="submit" className="login-button">Log In</button>
        </form>
        {message && <div className='message-box'>
          <p>{message}</p>
        </div>}
      </div>
      <p className="register-link">New? <a href="/signup" className="register-link">Register Here!</a></p>
      <DiscSignIn />
    </div>
  );
};

export default SignIn;
